import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M3.5 4C2.67188 4 2 4.67188 2 5.5C2 5.97187 2.22188 6.41562 2.6 6.7L9.4 11.8C9.75625 12.0656 10.2438 12.0656 10.6 11.8L17.4 6.7C17.7781 6.41562 18 5.97187 18 5.5C18 4.67188 17.3281 4 16.5 4H3.5ZM2 7.5V14C2 15.1031 2.89688 16 4 16H16C17.1031 16 18 15.1031 18 14V7.5L11.2 12.6C10.4875 13.1344 9.5125 13.1344 8.8 12.6L2 7.5Z",
      fill: "#A1A1A1"
    }, null, -1)
  ])))
}
export default { render: render }